import { auth } from '../firebase';
import { resolveApiUrl } from './apiBaseUrl';

async function getBearerToken(): Promise<string | null> {
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}

/** Fetch wrapper that attaches the Firebase ID token as a Bearer token. */
export async function apiFetch(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const token = await getBearerToken();
  const headers = new Headers(init?.headers);
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(resolveApiUrl(input), { ...init, headers });
}

/** Extract a user-facing message from a failed API response, or fall back. */
export async function readApiErrorMessage(response: Response, fallback: string): Promise<string> {
  const data = await response.json().catch(() => ({}));
  return data.error || data.message || fallback;
}
